module.exports = __webpack_public_path__ + "static/media/saadan_navigere_graphic.af6b5b3d.png";